/**
 * Diem vao duy nhat cho pdf.js trong toan bo ung dung.
 *
 * QUY UOC KIEN TRUC: pdf.js CHI duoc dung cho duong doc (raster xem truoc,
 * lop van ban de chon/tim kiem/doc man hinh). Duong GHI la cua loi Rust/PDFium.
 * Khong bao gio dung pdf.js de sinh ra byte PDF moi.
 *
 * Giay phep: pdf.js la Apache-2.0 - dung duoc trong san pham dong ma nguon.
 */
import * as pdfjsLib from 'pdfjs-dist';
// Duong dan worker PHAI di qua bo giai module cua Vite (hau to ?url), khong
// duoc dung new URL('pdfjs-dist/...', import.meta.url): new URL KHONG chay bo
// giai goi cua Node/Vite, no chi ghep chuoi tuong doi vao URL cua module hien
// tai. Ket qua se la /src/core/pdfjs-dist/build/pdf.worker.min.mjs -> 404 ->
// pdf.js AM THAM quay ve "fake worker" chay tren luong chinh, va giao dien
// dung hinh khi mo file lon. Day dung la loi ma khoi chu thich cu canh bao
// nhung lai tu mac phai.
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export { pdfjsLib };

/**
 * KIEU DUOC SUY RA TU CHINH API, KHONG IMPORT THEO TEN.
 *
 * pdfjs-dist khong cong bo PDFDocumentProxy / PDFPageProxy / RenderTask trong
 * danh sach export o goc goi - chung la lop noi bo cua display/api. Viet
 * import type { PDFPageProxy } from 'pdfjs-dist' se hong ngay o buoc typecheck,
 * con tro thang vao 'pdfjs-dist/types/src/display/api' thi gan chat vao bo cuc
 * thu muc noi bo cua goi va vo o ban sau. Suy ra tu kieu tra ve cua getDocument
 * thi dung o ca 4.x, 5.x va 6.x ma khong phu thuoc vao dieu gi ca.
 */
export type PDFDocumentProxy = Awaited<
  ReturnType<typeof pdfjsLib.getDocument>['promise']
>;
export type PDFPageProxy = Awaited<ReturnType<PDFDocumentProxy['getPage']>>;
export type PdfRenderTask = ReturnType<PDFPageProxy['render']>;

/** Mo tai lieu tu byte. pdf.js SE chiem quyen so huu buffer - luon truyen ban sao. */
export function loadDocument(bytes: Uint8Array, password?: string) {
  return pdfjsLib.getDocument({
    data: bytes.slice(),
    // Chi dat khoa 'password' khi that su co - tranh gui undefined tuong minh.
    ...(password !== undefined ? { password } : {}),
    // Tat font he thong de ket qua chan doan font phan anh dung file,
    // khong bi trinh duyet thay the ngam.
    useSystemFonts: false,
    // Can cho phan chan doan: ta doc du lieu font tu commonObjs.
    disableFontFace: false,
    isEvalSupported: false,
  });
}

/** Ma loi cua pdf.js -> ma loi trong hop dong dung chung. */
export function pdfjsErrorName(err: unknown): string {
  if (err && typeof err === 'object' && 'name' in err) {
    return String((err as { name: unknown }).name);
  }
  return 'Error';
}

export function isCancelled(err: unknown): boolean {
  return pdfjsErrorName(err) === 'RenderingCancelledException';
}
